<template>
  <div class="earn-sections-cover">
    <section class="bg-white  p-3">
      <div class="flex justify-end items-center gap-2 relative">
        <div class="px-2 py-2 flex items-center justify-between  silver-tier">
          <img v-if="tierTitle == 'No Tier'" src="../../../../views/3pl/BillingandCollection/icons/no-tier-icon.svg"
            alt="star">
          <img v-if="tierTitle == 'Silver'" src="../../../../views/3pl/BillingandCollection/icons/star.svg" alt="star">
          <h3>{{ tierTitle }} {{ commissionRate}} </h3>
          <img class="cursor-pointer" @click="openTierModal"
            src="../../../../views/3pl/BillingandCollection/icons/eye.svg" alt="eye">
        </div>
        <div>

          <img class="cursor-pointer" src="../../../../views/3pl/BillingandCollection/icons/tool-tip.svg" alt="eye">

          <div class="tooltip-box">
            <h4>Total Transactions</h4>
            <p>The total number of completed transactions within the selected period.</p>
            <h4>Total Revenue (TR)</h4>
            <p>Sum of all revenue inclusive of tips generated through the platform and offline during the selected
              period.</p>
            <h4>Total Earnings</h4>
            <p>The total income earned by the 3PL partner from all completed transacctions</p>
            <h4>Platform Collection</h4>
            <p>Amount collected via in-app payments (wallet or card) on the MuleEx platform.</p>
            <h4>Direct Collection</h4>
            <p>Amount collected by the 3PL partner directly from customers.</p>
            <h4>Paid</h4>
            <p>Total payouts and cashout made to the 3PL partner.</p>
            <h4>Current Balance</h4>
            <p>Earnings less amount paid and direct collections and any credits</p>
            <h4>Credit (Account Receivable)</h4>
            <p>Account receivables for credit received by customers from the 3PL</p>
          </div>
        </div>
      </div>

      <div v-if="showTierModal && currentTier === 'Silver'">
        <SilverTierModal @close-modal="closeTierModal" @open-work-modal="openWorkModal" />
      </div>
      <div v-if="showTierModal && currentTier === 'Gold'">
        <GoldTierModal @close-modal="closeTierModal" @open-work-modal="openWorkModal" />
      </div>
      <div v-if="showTierModal && currentTier === 'Diamond'">
        <DiamondTierModal @close-modal="closeTierModal" @open-work-modal="openWorkModal" />
      </div>

      <div v-if="showWorkModal">
        <WorkModal @close-work-modal="closeWorkModal" @open-prev-modal="openPrevModal" />
      </div>

      <div v-if="loading" class="flex justify-center items-center py-10">
        <div class="loader"></div>
        <p class="ml-2">Fetching your earnings...</p>
      </div>

      <div v-if="!loading" class="flex-wrap flex  metrics-wrap first-wrapper px-1 pt-1 pb-2">

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/TransactionIcon.svg" alt="">
            <div class="metrics-content">
              <p>TOTAL NO. OF TRANSACTIONS</p>
              <h4> {{ (Paymentdetails.totalNumberOfTransaction || 0).toLocaleString() }}</h4>

            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/RevenueIcon.svg" alt="">
            <div class="metrics-content">
              <p>TOTAL REVENUE</p>
              <h4> ₦ {{ formatAmount(Paymentdetails.totalRevenue) }} </h4>
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/EarningIcon.svg" alt="">
            <div class="metrics-content">
              <p>TOTAL EARNINGS</p>
              <h4> ₦ {{ formatAmount(Paymentdetails.totalEarning) }} </h4>
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex pl-4 ">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/Payouts.svg" alt="">
            <div class="metrics-content">
              <p>PLATFORM COLLECTION</p>
              <h4> ₦ {{ (Paymentdetails.platformCollection || 0).toLocaleString() }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="flex-wrap flex  metrics-wrap second-wrapper px-1 pb-1 pt-2">

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/TransactionIcon.svg" alt="">
            <div class="metrics-content">
              <p>DIRECT COLLECTION</p>
              <h4> ₦ {{ formatAmount(Paymentdetails.partnerCollection) }} </h4>

            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/RevenueIcon.svg" alt="">
            <div class="flex items-center justify-between w-full">
              <div class="metrics-content">
                <p>PAID</p>
                <h4> ₦ {{ formatAmount(Paymentdetails.payout) }} </h4>
              </div>
              <img @click="openPaidHistoryModal" class="cursor-pointer mr-2"
                src="../../../../views/3pl/BillingandCollection/icons/icon-eye-paid.svg" alt="">
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex pl-4 metrics-wrap-cover">
            <img class="mr-2" src="../../../../views/3pl/BillingandCollection/icons/EarningIcon.svg" alt="">
            <div class="metrics-content">
              <p>CURRENT BALANCE</p>
              <!-- <h4> ₦ {{ formatAmount(Paymentdetails.payoutBalance) }} </h4> -->
              <h4>
                <span v-if="Paymentdetails.payoutBalance < 0">
                  -₦ {{ formatAmount(Math.abs(Paymentdetails.payoutBalance)) }}
                </span>
                <span v-else>
                  ₦ {{ formatAmount(Paymentdetails.payoutBalance) }}
                </span>
              </h4>
            </div>
          </div>
        </div>

        <div class="py-2">
        </div>
      </div>

    </section>


    <div v-if="!loading" class="bg-white">
      <TableFilter @open-cash-modal="cashModal = true" />
    </div>

    <section v-if="!loading" class="bg-white section-two">
      <div class=" flex justify-between flex-wrap ">
        <div class="flex justify-between search-cover  px-4">
          <span class=" mr-2"><search-icon /> </span>

          <input type="text" class="" placeholder="Search..." v-model="searchString" />
          <img @click="openFilterModal" class="cursor-pointer" src="@/assets/images/icons/search.svg"
            alt="search icon" />
        </div>

        <div v-if="customDate" class="filter-wrap flex justify-between item-center gap-2 ">

          <!-- <el-date-picker @change="logStart" type="date" placeholder="Start Date" style="margin: 0" value-format="yyyy-MM-dd"  v-model="startDateCycle" /> -->
          <el-date-picker @change="logStart" type="date" placeholder="Start Date" style="margin: 0"
            value-format="yyyy-MM-dd" v-model="startDate" />
          <span class="pt-2">To</span>
          <!-- <el-date-picker @change="logEnd"  type="date" placeholder="End Date" style="margin: 0" value-format="yyyy-MM-dd" v-model="endDateCycle" /> -->
          <el-date-picker @change="logEnd" type="date" placeholder="End Date" style="margin: 0"
            value-format="yyyy-MM-dd" v-model="endDate" />
          <!-- Reset button now shows here when in custom -->
          <div @click="resetDateCycle()"
            class=" ml-2 undo-wrap flex justify-center items-center px-2 py-2 cursor-pointer">
            <img width="25" src="../../../../views/3pl/BillingandCollection/icons/undo.svg" alt="reset" />
          </div>
        </div>

        <div v-else class="filter-wrap-cover flex justify-between items-center">

          <div class="cycle-cover py-2 px-2 flex gap-2 justify-between items-center">
            <div class="flex justify-center gap-2 item-center icons-wrap">
              <img width="20" src="../../../../views/3pl/BillingandCollection/icons/CalendarIcon.svg" />
              <img width="1" src="../../../../views/3pl/BillingandCollection/icons/Line 80.svg" />
            </div>
            <div>
              <el-dropdown trigger="click" class="h-full  w-full">
                <div class="flex justify-between items-center cycle-cover-wrap">
                  <span>
                    <span class="inline-block whitespace-nowrap ">

                      {{ selectedCycle ? selectedCycle.label : '' }}
                    </span>
                  </span>
                  <ArrowDownBlackIcon :style="{ width: '16px' }" color="black" />
                </div>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="(cycle, index) in dateCycles" :key="index">
                    <button @click="setCycleType(cycle)">{{ cycle.label }}</button>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>
                    <button @click="setCycleType('custom')">Custom</button>
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div @click="resetDateCycle()" class="undo-wrap flex justify-center item-center  px-2 py-2 cursor-pointer">
            <img width="25" src="../../../../views/3pl/BillingandCollection/icons/undo.svg" alt="">
          </div>
        </div>

      </div>
    </section>
    <div v-if="!loading">
      <div v-if="isEmptyData" class="empty-earnings ">
        <img src="../../../../views/3pl/BillingandCollection/icons/wallet-earnings-empty.svg" alt="No data" />
        <p class="text-center py-10">No earnings to display. Your earnings will show here once you have completed your
          first delivery.</p>
      </div>
      <div v-else>
        <EarnPayTable :transactions="allTransactions" :batchments="batchments" />
        <div class="px-3">
          <pagination :total="Paymentdetails.pagination.totalRecords" :pageNumber="pageNumber"
            @pageNumber="setNumDisplayEarning" @pageSize="pageSize" />
        </div>
      </div>
    </div>

    <!-- </div> -->

    <div v-if="cashModal">
      <Cashout @close-cash-modal="cashModal = false" @cashedOut="cashedOut" :payout="payout" />
    </div>
    <div v-if="showPaidHistoryModal">
      <PaidHistoryModal @close-payhistory-modal="closePaidHistoryModal" />
    </div>
    <PriceInfo :showModal="isPriceInfo" @close-modal="isPriceInfo = false" />
    <EarnSearchFilter @appliedRef="appliedReference" @filteredCycle="filteredCycle" :show-modal="showFilterModal"
      @close-modal="showFilterModal = false" :loading="loading" :allTransactions="allTransactions" />
  </div>
</template>


<script>
import EarnSearchFilter from "./Modals/EarnSearchFilter.vue";
import ArrowDownBlackIcon from "../../../UI/svgs/ArrowDownBlackIcon.vue";
import pagination from "../../../UI/pagination.vue";
import moment from "moment";
import TableFilter from "../../../../views/3pl/BillingandCollection/modules/EarningTableFilter.vue";
import EarnPayTable from "../../../../views/3pl/BillingandCollection/modules/EarningTable.vue";
import Cashout from "../../../../views/3pl/BillingandCollection/modals/Cashout.vue";
import PriceInfo from "../../../../views/3pl/BillingandCollection/modals/PriceInfo.vue";
import debounce from "@/utilities/debounce";
import SilverTierModal from "./Modals/SilverTierModal.vue";
import GoldTierModal from "./Modals/GoldTierModal.vue";
import DiamondTierModal from "./Modals/DiamondTierModal.vue";
import PaidHistoryModal from "./Modals/PaidHistoryModal.vue";

import WorkModal from "./Modals/WorkModal.vue";

export default {
  components: {
    EarnSearchFilter,
    PaidHistoryModal,
    WorkModal,
    Cashout,
    SilverTierModal,
    GoldTierModal,
    DiamondTierModal,
    TableFilter,
    EarnPayTable,
    ArrowDownBlackIcon,
    PriceInfo,
    pagination
  },

  data() {
    return {
      
      showFilterModal: false,
      payout: 0,
      selectedCycle: null,
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("M"),
      customDate: false,
      dateCycles: [],
      dateCycleLabel: "",
      showTierModal: false,
      showPaidHistoryModal: false,
      showWorkModal: false,
      loading: true,
      cashModal: false,
      isPriceInfo: false,
      allTransactions: [],
      batchments: [],
      Paymentdetails: {},
      currentTier: '',
      currentTierProgress: '',
      commissionRate: '',
      searchString: "",
      filteredVal: "",
      interval: "custom",
      filterTitle: 'This Month',
      statusFilter: '',
      startDate: '',
      endDate: "",
      startDateCycle: null,
      endDateCycle: null,
      pageNumber: 1,
      earnsPerPage: 10,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
    };
  },
  watch: {
    startDate(val) {
      if (val && this.endDate && this.interval === 'custom') {
        this.getAllEarnAndPay();
      }
    },

    searchString: debounce(function (val) {
      this.filteredVal = val
      this.pageNumber = 1; // reset to first page on search
      this.getAllEarnAndPay();
    }, 500),

    endDate(val) {
      if (val && this.startDate && this.interval === 'custom') {
        this.getAllEarnAndPay();
      }
    },
    "sortProps": debounce(function () {
      if (this.interval == 'custom' && this.startDate && this.endDate && (this.endDate > this.startDate)) {
        this.earnPayload.startDate = this.sortProps.startDate;
        this.earnPayload.endDate = this.sortProps.endDate
        this.getAllEarnAndPay();
      }
    }, 500),
    "earnFilterPayload": debounce(function () {
      if (this.currentYear && this.currentMonth) {
        this.getEarnAndPayDateCycle();
      }
    }, 500),
  },

  computed: {
    isEmptyData() {
      const details = this.Paymentdetails || {};
      const noTransactions =
        !this.allTransactions || this.allTransactions.length === 0;

      const noTotals =
        (!details.totalRevenue || details.totalRevenue === 0) &&
        (!details.totalEarning || details.totalEarning === 0) &&
        (!details.totalNumberOfTransaction || details.totalNumberOfTransaction === 0);

      return noTransactions && noTotals;
    },
    // startYear() {
    //   return this.startDateCycle ? Number(this.startDateCycle.split('-')[0]) : ''
    // },
    // endMonth() {
    //   return this.endDateCycle ? Number(this.endDateCycle.split('-')[1]) : ''
    // },
    tierTitle() {
      switch (this.currentTier) {
        case 'Silver':
          return 'Silver';
        case 'No Tier':
          return 'No Tier';
        case 'Gold':
          return 'Gold';
        case 'Platinum':
          return 'Platinum';
        case 'Diamond':
          return 'Diamond';
        default:
          return 'No Tier';
      }
    },
    tierPercentage() {
      switch (this.currentTier) {
        case 'silver':
          return '15%';
        case 'gold':
          return '25%';
        case 'platinum':
          return '35%';
        case 'diamond':
          return '45%';
        case 'No Tier':
          return '';
        default:
          return '';
      }
    },
    sortProps() {
      return {
        pageSize: this.earnsPerPage,
        pageNum: this.pageNumber,
        interval: this.interval,

        startDate: this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    },

    earnFilterPayload() {
      return {
        year: this.currentYear,
        month: this.currentMonth
      }
    },

    earnPayload() {
      return {
        customerType: '3PL',
        // searchTerm: this.sortOptions.searchString,
        searchTerm: this.searchString,
        interval: this.interval,
        statusFilter: this.statusFilter,

        ...(this.startDate ? { startDate: moment(this.startDate).format('YYYY-MM-DD') } : {}),
        ...(this.endDate ? { endDate: moment(this.endDate).format('YYYY-MM-DD') } : {}),
        pageSize: this.earnsPerPage,
        pageNum: this.pageNumber
      }
    },
  },

  mounted() {
    this.getViewTierHistory()
    this.getEarnAndPayDateCycle()
   
  },

  methods: {
  
    openFilterModal() {
      this.searchString = ''
      this.earnFilterPayload.year = this.currentYear
      this.earnFilterPayload.month = this.currentMonth
      this.showFilterModal = !this.showFilterModal
    },
    filteredCycle(month, year) {
     
      this.earnFilterPayload.year = year
      this.earnFilterPayload.month = month
      this.getEarnAndPayDateCycle()
    },
    appliedReference(filteredVal) {
      this.searchString = filteredVal
    },
    logStart() {
      // this.currentYear = this.startYear 
    },
    logEnd() {
      // this.currentMonth = this.endMonth
    },
    setCycleType(cycle) {
      if (cycle === 'custom') {
        this.customDate = true
        this.selectedCycle = { startDate: "", endDate: "", label: "Custom" }
      } else {
        this.customDate = false
        this.selectedCycle = cycle
      }
      this.startDate = cycle.startDate
      this.endDate = cycle.endDate
    },
    resetDateCycle() {
      // Reset to current month/year
      this.currentYear = moment().format("YYYY");
      this.currentMonth = moment().format("M");

      // Reset start/end dates
      this.startDate = "";
      this.endDate = "";

      // Hide custom datepicker
      this.customDate = false;

      // Clear selected cycle
      this.selectedCycle = null;

      // Refetch cycles and data
      this.getEarnAndPayDateCycle();
    },

    openPrevModal() {
      this.showWorkModal = false;
      this.showTierModal = true;
    },
    openWorkModal() {
      this.showWorkModal = true;
    },
    closeWorkModal() {
      this.showWorkModal = false;
      this.showTierModal = false;
    },
    openTierModal() {
      this.showTierModal = true;
    },
    closeTierModal() {
      this.showTierModal = false;
    },
    closePaidHistoryModal() {
      this.showPaidHistoryModal = false;
    },
    openPaidHistoryModal() {
      this.showPaidHistoryModal = true;
    },
    setStatusChanges(val) {
      this.statusFilter = val
    },

    formatAmount(number) {
      return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    goBack() {
      this.$router.go(-1)
    },
    setNumDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.searchString = val.searchString
      this.sortOptions = { ...this.sortOptions, ...val };
    },

   

    async getAllEarnAndPay() {
      this.loading = true;
      try {
        let response = await this.$_getEarnAndPayout(this.earnPayload);
        this.allTransactions = response.data.data.allTransaction;
        this.batchments = response.data.data.batchments;
        this.Paymentdetails = response.data.data;
        this.payout = this.Paymentdetails.payoutBalance;
      } catch (error) {
        this.generateToast(
          error.response?.data?.data?.message || "Something went wrong",
          "error"
        );
      } finally {
        this.loading = false; // hide loader regardless of success/failure
      }
    },

    async getEarnAndPayDateCycle() {
      this.loading = true;
      try {
        let response = await this.$_getEarnAndPayoutDateDropdown(this.earnFilterPayload);
        this.dateCycles = response.data.data;

        if (this.dateCycles.length > 0 && !this.selectedCycle) {
          const today = new Date();
          const cycle = this.dateCycles.find(c => {
            const start = new Date(c.startDate);
            const end = new Date(c.endDate);
            return today >= start && today <= end;
          });
          this.selectedCycle = cycle || this.dateCycles[0];
          this.earnPayload.startDate = this.selectedCycle.startDate;
          this.earnPayload.endDate = this.selectedCycle.endDate;
          await this.getAllEarnAndPay();
        }
      } catch (error) {
        this.generateToast(
          error.response?.data?.data?.message || "Something went wrong",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },

    async getViewTierHistory() {
      let response = await this.$_getTeirCategory({ customerType: '3PL', fleetType: "Bike" })
      if (['silver', 'gold', 'platinum', 'diamond'].includes(response.data.currentTier?.toLowerCase())) {
        this.currentTier = response.data.currentTier;
        this.currentTierProgress = response.data.progressToNextTier;
        this.commissionRate = response.data.commissionRate       
      } else {
        this.currentTier = response.data.currentTier;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loader {
  border: 4px solid #f3f3f3;
  /* Light grey */
  border-top: 4px solid #3F5F8E;
  /* Primary color */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.empty-earnings {
  background-color: #F2F7FC;
  padding-top: 5%;
 
}

.empty-earnings>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 600;
}

.empty-earnings>img {
  margin: 0 auto;
}

.earn-sections-cover>:nth-child(1)>:nth-child(1)>:nth-child(2):hover .tooltip-box {
  display: block;
}

.tooltip-box {
  display: none;
  position: absolute;
  top: 60%;
  right: 0;
  width: 280px;
  background-color: #10233e;
  color: #F0F4FE;
  padding: 16px;
  border-radius: 8px;
  z-index: 999;
  font-size: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.tooltip-box h4 {
  margin: 10px 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.tooltip-box p {
  font-weight: 400;
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
}


.search-cover {
  background-color: #7B858F1A;
  flex-basis: 40%;
  border-radius: 50px;
  align-items: center;

}

.filter-wrap {
  // border: 1px solid #FFFFFF;
  // border: 1px solid blue;
  border-radius: 5px;
  // box-shadow: 0 4px 6px -1px #0807081A;
  flex-basis: 30%;
  // div{
  //   // border: 1px solid red;
  // }
}

.filter-wrap-cover {
  flex-basis: 30%;
}

.cycle-cover {
  border-radius: 5px;
  box-shadow: 0 4px 6px -1px #0807081A;
  border: 1px solid #FFFFFF;
  flex-basis: 75%;
}


.cycle-cover>:nth-child(1) {

  flex-basis: 20%;
}

.cycle-cover>:nth-child(2) {

  flex-basis: 75%;
}

.undo-wrap {
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 4px 6px -1px #0807081A;
  flex-basis: 20%;
}

::v-deep(.el-dropdown-menu__item:hover) {
  background-color: #09B78A12 !important; // your custom background
  color: #09B78A !important; // your preferred text color
  border-radius: 124px !important; // your preferred text color
}

.search-cover>input {
  background-color: transparent;
  width: 100%;
}
.earn-sections-cover{
background: white;
}
.section-two>:nth-child(1) {
  padding-left: 1.5%;
  padding-right: 1.5%;
  padding-bottom: 1.5%;
}

.silver-tier {
  width: 20%;
  border-radius: 100px;
  box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
  margin-top: 4%;
  margin-bottom: 4%;
}

.silver-tier>h3 {
  font-weight: 400;
  font-size: 14px;
  color: #A5ADB7;
}

.first-wrapper {
  border-top: 1px dashed #878E99;
  border-right: 1px dashed #878E99;
  border-left: 1px dashed #878E99;
}

.second-wrapper {
  border-bottom: 1px dashed #878E99;
  border-right: 1px dashed #878E99;
  border-left: 1px dashed #878E99;
}

.metrics-wrap>div {
  width: 25%;
  align-items: center;
  background: #FAFBFF;
}

.metrics-wrap>:nth-child(1) {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.metrics-wrap>:nth-child(4) {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.metrics-wrap-cover {
  border-right: 1px dashed #4142455C;
}

.metrics-content>p {
  color: #7A90A7;
  font-weight: 700;
  font-size: 12px;
}

.metrics-content>h4 {
  color: #383F51;
  font-weight: 600;
  font-size: 16px;
}

.btn_arrow {
  @apply inline-flex items-center
}

.lft_arrow {
  @apply inline-block rotate-90 w-3 mr-2
}

.w_semi {
  align-items: center;
  display: flex;
  width: 100%;
  // border: 1px solid green;
  margin: 2%;
}

.drp-content {

  // border: 1px solid yellow ;
  width: 100%;
  border-radius: 12px;
  padding: 3%;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.vrt_line {
  width: 2px;
  height: 17px;
  background-color: #383F51;
  display: inline-block;
}

@media (max-width: 1115px) {
  .filter-wrap-cover {
    flex-basis: 35%;

  }

  .silver-tier {
    width: 30%;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(2) {
    margin-bottom: 2%;
  }

  .metrics-wrap>div {
    width: 50%;

  }

  .metrics-wrap>:nth-child(3) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .metrics-wrap>:nth-child(2) {

    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    .metrics-wrap-cover {
      border-right: none;
    }
  }
}




@media (max-width: 768px) {
  .filter-wrap-cover {
    flex-basis: 45%;
  }

  .silver-tier {
    width: 45%;
  }

  .section-two>:nth-child(1) {

    padding-left: 3%;
    padding-right: 3%;
  }

  .second-wrapper>:nth-child(4) {
    display: none;
  }

  .metrics-wrap>div {
    width: 100%;
  }

  .first-wrapper>:nth-child(4) {
    margin-top: 4%;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(2) {
    margin-bottom: 4%;
  }

  .metrics-wrap>:nth-child(2),
  .metrics-wrap>:nth-child(4) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .metrics-wrap>:nth-child(1),
  .metrics-wrap>:nth-child(3) {

    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    .metrics-wrap-cover {
      border-right: none;
    }
  }
}

@media (max-width: 430px) {
  // .filter-wrap-cover {
  //   width: 100%;
  // }

  .silver-tier {
    width: 60%;
  }

  .section-two>:nth-child(1) {
    display: block;
  }

  .date-picker,
  .search-cover {
    margin-bottom: 3%;
  }

  .date-picker {
    justify-content: center;
  }

  .filter-wrap {
    margin-bottom: 4%;
  }

}
</style>
